import { getRegisterFunction } from '../../utils/register.js';
import { OneUxTabElement } from './OneUxTabElement.js';
export const register = getRegisterFunction(OneUxTabElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-tab': OneUxTabElement;
    "tab-ee08a666e009cdb4313d519e04691f19": OneUxTabElement;
  }
}